import { css } from 'styled-components';

export const progressStyle = css`
    height: 6px;
    border-radius: 5px;
    overflow: hidden;
`;
